/** The DFC page loader: the 30x30 ring artwork turning round the still "30x30" lettering. */
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import { SurfaceProp, omit } from '../style';

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.45; }
`;

export const LoaderScreen = styled('div', omit('surface', 'fullScreen'))<
  SurfaceProp & { fullScreen: boolean }
>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: ${({ fullScreen }) => (fullScreen ? '100vh' : '60vh')};
  ${({ fullScreen }) => (fullScreen ? 'min-height: 100dvh;' : '')}
  background: ${({ surface }) => surface.pageBg};
`;

export const Mark = styled('div')`
  position: relative;
  width: 92px;
  height: 92px;
`;

export const Ring = styled('img')`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  animation: ${spin} 1.1s linear infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: ${pulse} 1.6s ease-in-out infinite;
  }
`;

export const Numerals = styled('img')`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
`;

export const VisuallyHidden = styled('span')`
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
`;
